export function wisepops(action: string, ...args) {
  try {
    if (window.wisepops) {
      window.wisepops(action, ...args);
    }
  } catch {
    console.warn('failed to call wisepops'); // eslint-disable-line no-console
  }
}

export function wispNewPage() {
  try {
    if (window.wisp) {
      window.wisp.newPage();
    }
  } catch {
    console.warn('failed to call wisp.newPage'); // eslint-disable-line no-console
  }
}
